import {stopPropagation} from '@dvrd/dvr-controls';

import './style/bluemateCollapsibleSection.scss';

import {Icon} from '@iconify/react';

import classNames from 'classnames';

import React, {PropsWithChildren, ReactNode, useState} from 'react';

import {BluemateCollapsibleSectionSize} from '../../../util/types';

interface Props {
    title: string;
    subtitle?: string;
    icon?: string;
    size?: BluemateCollapsibleSectionSize;
    defaultOpen?: boolean;
    open?: boolean;
    onToggle?: (open: boolean, evt: React.MouseEvent) => void;
    rightContent?: ReactNode;
    children: ReactNode;
    className?: string;
}

export default function BluemateCollapsibleSection(props: PropsWithChildren<Props>) {
    const {title, subtitle, icon, size = 'normal', defaultOpen = true, rightContent, children, className} = props;
    const [internalOpen, setInternalOpen] = useState(defaultOpen);

    const isControlled = props.open !== undefined;
    const isOpen = isControlled ? props.open! : internalOpen;

    function handleToggle(event: React.MouseEvent) {
        const next = !isOpen;
        if (isControlled) {
            props.onToggle?.(next, event);
        } else {
            setInternalOpen(next);
        }
    }

    return (
        <div
            className={classNames(
                'bluemate-collapsible-section',
                `size-${size}`,
                isOpen && 'open',
                subtitle && 'with-subtitle',
                className
            )}
        >
            <div className='bluemate-collapsible-header' onClick={handleToggle}>
                <div className='bluemate-collapsible-header-left'>
                    {icon && <Icon icon={icon} className='bluemate-collapsible-icon' />}
                    {subtitle ? (
                        <div className='bluemate-collapsible-heading'>
                            <span className='bluemate-collapsible-title'>{title}</span>
                            <span className='bluemate-collapsible-subtitle'>{subtitle}</span>
                        </div>
                    ) : (
                        <span className='bluemate-collapsible-title'>{title}</span>
                    )}
                    <Icon icon='mdi:chevron-down' className='bluemate-collapsible-chevron' />
                </div>
                {rightContent && (
                    <div className='bluemate-collapsible-header-right' onClick={stopPropagation}>
                        {rightContent}
                    </div>
                )}
            </div>
            {isOpen && <div className='bluemate-collapsible-content'>{children}</div>}
        </div>
    );
}
